<template>
  <div id="price" class="pa-7">
    <!--タイトル-->
    <span class="subHead">
      {{ title }}
    </span>
    <v-icon class="mb-2" color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--説明-->
    <div class="pa-5" id="priceDescription">
      {{ descriptions.description }}<br>
      <div id="asterisk">
        {{ descriptions.asterisk }}
      </div>
    </div>
  </div>
</template>

<style>
#priceDescription {
  line-height: 25px;
}
#asterisk {
  margin-top: 10px;
  color: #B71C1C;
}
</style>

<script>
export default {
  data  () {
    return {
      // タイトル
      title: '料金',
      // タイトル横アイコン
      icon: 'mdi-currency-usd',
      // 説明文
      descriptions: {
        description: '制作費用はテンプレートから選択される場合、総ページ数10頁100,000円(税別)',
        asterisk: '※Joomla等のオープンソースのCMSを利用される場合は、別途サーバー費用及び、セキュリティアップデートの月々の保守費用がかかります。'
      }
    }
  }
}
</script>
